import { useState } from "react";
import { Loader2, ShieldAlert } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

export function ImpersonationBanner() {
  const { isImpersonating, impersonationTenantName, stopImpersonation } =
    useAuth();
  const navigate = useNavigate();
  const [stopping, setStopping] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!isImpersonating) return null;

  async function handleStop() {
    setError(null);
    setStopping(true);
    try {
      await stopImpersonation();
      // Client-side zurück in den Platform-Bereich (kein Reload).
      navigate("/platform/tenants");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Beenden fehlgeschlagen.");
      setStopping(false);
    }
  }

  return (
    <div className="flex items-center gap-3 bg-amber-500 px-4 py-2 text-sm text-amber-950">
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span className="flex-1">
        Impersonation aktiv — du agierst als Tenant{" "}
        <span className="font-semibold">
          {impersonationTenantName ?? "Unbekannt"}
        </span>
        .
        {error && <span className="ml-2 font-medium">{error}</span>}
      </span>
      <Button
        size="sm"
        variant="outline"
        onClick={handleStop}
        disabled={stopping}
        className="border-amber-950/30 bg-white/80 text-amber-950 hover:bg-white"
      >
        {stopping ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Beenden...
          </>
        ) : (
          "Beenden"
        )}
      </Button>
    </div>
  );
}
